import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	position: relative;
	width: 100%;
	min-height: 100vh;
	overflow: hidden;

	.columns {
		display: flex;
		height: 100%;
		gap: 2em;

		.col {
			width: 50%;
			min-height: 100%;
		}

		.col-left {
			padding: 3em;
			display: flex;
			flex-flow: column wrap;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 2em;

			.button-homepage {
				margin: 2em 0;
				width: 100%;
				justify-content: flex-start;
			}
		}

		.col-right {
			position: relative;
			background-color: ${vars.colorPrimaryBlue};
			display: flex;
			justify-content: center;
			padding: 0 1em 0 3em;
			min-height: 100vh;
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		min-height: 60vh;
		.columns {
			.col-left {
				width: 80%;
			}
			.col-right {
				display: none;
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		.columns {
			.col-left {
				width: 100%;
				padding: 2em;

				.content-section-form-result-info {
					margin: 1em 0 4em 0;
				}
			}
		}
	}
`;
